<template>
    <span v-if="formatted.disableLink == true"> {{ formatted.symbolName }} </span>
    <a :href="getLink" v-if="!formatted.disableLink"> {{ formatted.symbolName }} </a>
</template>

<script setup>
import { computed } from 'vue';

const props = defineProps({
    raw: Object,
    formatted: Object,
    label: String,
});

const getLink = computed(() => window.route('quotes.futures', props.formatted.symbol));
</script>
